import { connect } from 'react-redux';
import * as common from '../../common/__redux/commonRedux'
import { useEffect, useState } from 'react';
import BarCode from '../../../../assets/icons/ic_barcode.svg';
import caretRightFilter from '../../../../assets/icons/ic_caret_right_filter.svg';
import searchIcon from '../../../../assets/icons/ic_search.svg';
import QRScanner from './QRScanner';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import SearchInputByBookingRef from './SearchInputByBookingRef';
import caretLeft from '../../../../assets/icons/ic_caret_left.svg';
import { getBookingDetails } from './networking';
import DialogLoader from '../../common/DialogLoader';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomToast from '../../common/CustomToast';
import {useHistory} from 'react-router-dom'
import ImageHelper from '../../../../utilities/helpers/ImageHelper';
import { DateFormatHelper } from '../../../../utilities/helpers/DateFormatHelper';
import ProfileImage from '../../common/ProfileImage';
import {ReactComponent as CheckInGreen} from '../../../../assets/icons/ic_checkin.svg'
import {ReactComponent as CheckInWhite} from '../../../../assets/icons/ic_check_in_green.svg'
import { NavigatorPaths } from '../../../../assets/dictionaries/NavigatorPaths';
import { checkInParticipants } from './networking';
import warning from "../../../../assets/icons/ic_warning_triangle.svg";
import success from "../../../../assets/icons/ic_success.svg";

const BarCodeMenu = (props) => {
    const dictionary = useDictionary();
    const [showDialog, setDialogVisibility] = useState(false);
    const [showBoxFilter, setShowBoxFilter] = useState(true);
    const [showScanner, setShowScanner] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    // const [showDetailsPopup, setShowDetailsPopup] = useState(false)
    const [localBookingDetails, setLocalBookingDetails] = useState(bookingDetails);
	const [permissionChecking, setPermissionChecking] = useState(false);
	const [selectedParticipants, setSelectedParticipants] = useState([]);
	const [errorMes , setErrorMes] = useState('');
	const [successMes , setSuccessMes] = useState('');
    const history = useHistory();
    const [qrSuccess, setQrSuccess] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setDialogVisibility(true);
        }, 50);

        return () => {
            setLoading(false);
            setBookingDetails(null);
            setLocalBookingDetails(null);
            setQrSuccess(false);
            setErrorMes('');
            setSuccessMes('');
        };
    }, []);

    const fetchBookingDetails = async (queryObject=null) => {
        setLoading(true);
        try {
            // const response = await getBookingDetails({ id: searchParam });
            const response = await getBookingDetails(queryObject);
            if(queryObject && queryObject.hasOwnProperty('qr_data')) {
                setQrSuccess(true);
            }
            setBookingDetails(response);
            setLocalBookingDetails(response);
            // setShowDetailsPopup(true);
        } catch (error) {
            if(error?.response?.data.error_code == 3200 || error?.response?.data.error_code == 3203) {
                toast.error(<CustomToast message={dictionary.errors[error.response.data.error_code]} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    toastId: `qr-${error.response.error_code}`,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-warning',
                });
            } else {
                toast.error(<CustomToast message={'Please scan a valid QR code and try again.'} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    toastId: `qr-error`,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-warning',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const dismissDialog = () => {
		setDialogVisibility(false);
		setTimeout(() => {
			props.setShowFilterDialog(false);
            setBookingDetails(null);
		}, 600);
	};
    
    const onCancelClicked = () => {
		dismissDialog();
	};

    const showScannerBox = () => {
        setBookingDetails(null);
        setErrorMes('');
        setSuccessMes('');
		if (showScanner) {
			setShowScanner(false);
			setShowBoxFilter(true);
		} else {
			setShowScanner(true);
			setShowBoxFilter(false);
		}
	}
    const showSearchBox = () => {
        setBookingDetails(null);
        setErrorMes('');
        setSuccessMes('');
		if (showSearch) {
			setShowSearch(false);
			setShowBoxFilter(true);
		} else {
			setShowSearch(true);
			setShowBoxFilter(false);
		}
	}


    const handleScanSuccess = (data) => {
        if(data && data.length > 0) {
            setTimeout(()=>{
                setShowBoxFilter(false);
                setShowScanner(true);
                fetchBookingDetails({qr_data:data[0]?.rawValue});
            },200)
        }
    };

    const onSearchValueChanged = (value) => {
        setErrorMes('');
        setSuccessMes('');
        fetchBookingDetails({ booking_reference: value });
	};

    const backToFilterList = () => {
        setShowBoxFilter(true);
        setShowSearch(false);
        setBookingDetails(null);
    }
    const handleParticipantToggle = (participantId, checkInStatus) => {
        setSelectedParticipants(prevState =>
            prevState.includes(participantId)
                ? prevState.filter(id => id !== participantId)
                : [...prevState, participantId]
        );

        if (checkInStatus === 1) {
            const updatedParticipants = localBookingDetails.data.participants.map(participant =>
                participant.id === participantId
                    ? { ...participant, check_in: 0 }
                    : participant
            );
            setLocalBookingDetails({
                ...localBookingDetails,
                data: {
                    ...localBookingDetails.data,
                    participants: updatedParticipants,
                },
            });
        }
    };

    const handleCheckInToggle = async () => {
		try {
			if(permissionChecking === true) {
				return;
			}
            setPermissionChecking(true);
			navigator.geolocation.getCurrentPosition(async (position) => {
				const location = `${position.coords.latitude},${position.coords.longitude}`;
				await performCheckIn(location);
				setPermissionChecking(false);
			}, (error) => {
                handleLocationError(error);
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 })
		} catch (error) {
			setLoading(false);
			setPermissionChecking(false);
			console.error('Error updating check-in status:', error);
		}
	};
	
	const handleError = (data) => {
		const { message, errors } = data;
	
		let errorMessages = [message];
	
		if (errors && errors.length > 0) {
			errorMessages = errorMessages.concat(
				errors.map(err => `${err.message}`)
			);
		}
	
		const uniqueErrorMessages = [...new Set(errorMessages)];
		if(message) {
			setSuccessMes('');
			setErrorMes(uniqueErrorMessages.join('\n') ? uniqueErrorMessages.join('\n') : message);
			return;
		}
	
		toast.error(<CustomToast message={uniqueErrorMessages.join('\n')} />, {
			position: 'bottom-left',
			autoClose: 5000,
			toastId: 'header-toast-2',
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: false,
			progress: undefined,
			closeButton: false,
			icon: false,
			className: 'toast-white-warning'
		});
	
	};
	
	const performCheckIn = async (location) => {
		const payload = {
			participants: selectedParticipants,
			force: false,
			location: location,
		};

		setLoading(true);

		try {
			const response = await checkInParticipants(payload);

			if (response.data.success) {
				const updatedParticipants = localBookingDetails.data.participants.map((participant) =>
					selectedParticipants.includes(participant.id)
						? { ...participant, check_in: 1 }
						: participant
				);

				setLocalBookingDetails({
					...localBookingDetails,
					data: {
						...localBookingDetails.data,
						participants: updatedParticipants,
					},
				});

				toast.success(<CustomToast message={response.data.message} />, {
					position: 'bottom-left',
					autoClose: 5000,
					toastId: 'header-toast-3',
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
					closeButton: false,
					icon: false,
					className: 'toast-white-warning',
				});
				if(response.data.message) {
					setErrorMes('');
					setSuccessMes(response.data.message);
				}

				setSelectedParticipants([]);
			} else {
				setSelectedParticipants([]);
				handleError(response.data);
			}
			setLoading(false);
		} catch (err) {
			console.error('Error during check-in:', err);
			setLoading(false);
		}
	};
	const handleLocationError = (error) => {
		setPermissionChecking(true);
		if(permissionChecking === true) {
            return;
		}
		if (error.code === error.PERMISSION_DENIED) {
			navigator.geolocation.getCurrentPosition(
				async (position) => {
					const location = `${position.coords.latitude},${position.coords.longitude}`;
					await performCheckIn(location);
					setPermissionChecking(false);
					setLoading(false);
				},
				async (error) => {
					await performCheckIn('');
					setPermissionChecking(false);
					setLoading(false);
				},
				{ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
			);
		} else {
			setPermissionChecking(false);
		}
	};
	
	
	
    const handleSelectAll = () => {
		if (selectedParticipants.length === localBookingDetails.data.participants.filter(p => p.check_in === 0).length) {
			setSelectedParticipants([]);
        } else {
			const allParticipantIds = localBookingDetails.data.participants
				.filter(p => p.check_in === 0)
				.map(p => p.id);
			setSelectedParticipants(allParticipantIds);
		}
	};

	const viewBookingHandler = (bookingId) => {
		dismissDialog();
		setShowSearch(false);
	
		const currentBookingId = history.location.pathname.split('/').pop();
	
		if (currentBookingId !== bookingId) {
			history.push(`${NavigatorPaths.bookings.path}/${bookingId}`);
		} else {
			window.location.reload();
		}
	};

    return (
		<div
			onClick={() => onCancelClicked()}
			className="dialog-wrapper qr-code-menu"
			style={{ background: 'transparent', position: 'fixed', zIndex: '11' }}
		>
            <div
				onClick={(e) => e.stopPropagation()}
				className={
					showDialog
						? 'experience-category-tags-wrapper experience-category-tags-wrapper-visible'
						: 'experience-category-tags-wrapper'
				}
			>
                <div className="schedule-dialog-content-wrapper thin-scrollbar">
                    <div
						className="dialog-close-button"
						style={{ right: '24px', top: '21px' }}
						onClick={onCancelClicked}
						data-testid="schedule-dialog-close-button"
					/>
                    <div className="schedule-dialog-content-container schedule-dialog-content-container-pa-0">
						<div className="schedule-dialog-content-container-content border-bottom">
							<h2 style={{ whiteSpace: 'pre-line', fontSize: '16px', lineHeight: '24px', fontWeight: 500 }}>
                                {dictionary.Check_in}
							</h2>
						</div>
                    </div>
                    <div className="schedule-dialog-content-container-content">
                        {showBoxFilter ? (
							<div className="box-filter-list">
								<div className="group-filter">
									<div className="group-filter-icon-label">
										<img className="group-filter-icon" src={BarCode} />
										<span onClick={showScannerBox} className="group-filter-label">{dictionary.Scan_QR_Code}</span>
									</div>
									<img onClick={showScannerBox} className="icon-to-select" src={caretRightFilter} />
								</div>
								<div className="group-filter">
									<div className="group-filter-icon-label">
										<img className="group-filter-icon" src={searchIcon} />
										<span onClick={showSearchBox} className="group-filter-label">{dictionary.Search_by_Booking_Reference}</span>
									</div>
									<img onClick={showSearchBox} className="icon-to-select" src={caretRightFilter} />
								</div>
							</div>
						): null}
                        {showScanner && (
                            <QRScanner
                                onScanSuccess={handleScanSuccess}
                                setShowBoxFilter={setShowBoxFilter}
                                setShowScanner={setShowScanner}
                                setBookingDetails={setBookingDetails}
                                qrSuccess={qrSuccess}
                                setQrSuccess={setQrSuccess}
                            />
                        )}
                        {showSearch && (
                            <div>
                                <a href="#" onClick={backToFilterList} className="back-to-filter-list">
                                    <img src={caretLeft} />
                                    <span>{dictionary.back}</span>
                                </a>
                                <SearchInputByBookingRef onValueChanged={onSearchValueChanged} setBookingDetails={setBookingDetails}/>
                            </div>
                        )}
                        {bookingDetails && (
                            <div className={'header-booking-details'}>
                                <div className="thin-scrollbar">
                                    <div>
                                        {errorMes ? (
                                            <div className="d-flex overlap-warn-container" style={{margin: '32px 0px 24px 0px'}}>
                                                <img src={warning} />
                                                <div className="overlap-warn">
                                                    {errorMes}
                                                </div>
                                            </div>
                                        ) : null}
                                        {successMes ? (
                                            <div className="d-flex overlap-warn-container" style={{margin: '32px 0px 24px 0px', backgroundColor:'#f0fff4'}}>
                                                <img src={success} style={{margin:0}}/>
                                                <div className="overlap-warn">
                                                    {successMes}
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className='experience-thumbnail-image-container d-flex items-center'>
                                            <div className="experience-thumbnail-image">
                                                <img
                                                    onError={(e) => { e.currentTarget.src = ''; }}
                                                    src={bookingDetails?.data?.experience?.thumbnail_url ? ImageHelper.getFullImageUrl(bookingDetails?.data?.experience?.thumbnail_url) : ''}
                                                />
                                            </div>
                                            <div style={{ marginLeft: 12 }}>
                                                <h4 className="experience-thumbnail-image-text truncate" style={{ marginBottom: 8 }}>{bookingDetails?.data?.experience?.title}</h4>
                                                <h2 className="experience-thumbnail-slot-text truncate" title={DateFormatHelper.dayMonthTimeFormat(bookingDetails?.data?.slot.start_time)} style={{ marginBottom: 8 }}>{DateFormatHelper.dayMonthTimeFormat(bookingDetails?.data?.slot.start_time)}</h2>
                                                <div
                                                    onClick={() => viewBookingHandler(bookingDetails?.data?.booking?.id)}
                                                    className="experience-thumbnail-slot-text text-with-underline"
                                                    style={{ cursor: 'pointer', color: 'var(--brand-dark-blue)' }}
                                                >
                                                    {dictionary?.view_booking}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='participants-wrapper'>
                                            <div className='d-flex justify-between' style={{ marginBottom: 8 }}>
                                                <h4 className="experience-thumbnail-image-text truncate">{dictionary.participants}</h4>
                                                {
                                                    localBookingDetails?.data?.participants.length !== 0 ? (
                                                        <h4 className="experience-thumbnail-select-all fw-500 text-with-underline" onClick={handleSelectAll}>{selectedParticipants.length === localBookingDetails?.data?.participants.filter(p => p.check_in === 0).length ? dictionary.unselect_all: dictionary.select_all}</h4>
                                                    ) : null
                                                }
                                            </div>
                                            <div className="participants-list">
                                                {localBookingDetails?.data?.participants.map((participant, index) => (
                                                    <div className="participant" key={participant.id}>
                                                        <div className="booking-customer-container" style={{ gap: '8px' }}>
                                                            <ProfileImage name={participant.name} photo={participant.avatar_url} size={{ width: 40, height: 40, fontSize: 14, lineHeight: 16 }} />
                                                            <div>
                                                                <h4 className='truncate booking-customer-container-customername' style={{width:120,maxWidth:120}} title={participant.name ? participant.name : `${dictionary.participant} ${index + 1}`}>{participant.name ? participant.name : `${dictionary.participant} ${index + 1}`}</h4>
                                                                <h4 className='truncate booking-customer-container-customername booking-customer-container-group' style={{width:120,maxWidth:120}} title={participant.group}>{participant.group}</h4>
                                                            </div>
                                                        </div>
                                                        <div className='booking-customer-container-group' style={{ color: 'var(--brand-dark-blue)' }}>
                                                            {participant.check_in_allowed_quantity === 0
                                                                ? `${participant.check_in}`
                                                                : `${participant.check_in}/${participant.check_in_allowed_quantity}`}
                                                        </div>
                                                        <div className={`${participant.check_in === 1 ? 'checkbox pointer-events-none' : 'checkbox not-checked'}`} onClick={() => handleParticipantToggle(participant.id, participant.check_in)}>
                                                            {(participant.check_in === 1 || selectedParticipants.includes(participant.id)) ? <CheckInGreen /> : <CheckInWhite />}
                                                        </div>
                                                    </div>
                                                ))}
                                                {
                                                    localBookingDetails?.data?.participants.length === 0 ? (
                                                        <div className='participant-no-data'>
                                                            {dictionary.no_participant_found}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="group-dialog-button-container">
                    <button
                        disabled={selectedParticipants.length === 0}
                        onClick={handleCheckInToggle}
                        className={selectedParticipants.length > 0 ? 'button' : 'button button-disabled'}
                        data-testid="group-dialog-finish-button"
                    >
                        {dictionary.Check_in}
                    </button>
                </div>
            </div>
            {/* {showDetailsPopup && bookingDetails && (
                <BookingDetails bookingDetails={bookingDetails} setShowDetailsPopup={setShowDetailsPopup} setBookingDetails={setBookingDetails} setShowSearch={props.setShowFilterDialog}/>
            )} */}
            <DialogLoader showLoader={loading} />
            <ToastContainer/>
        </div>
    )
}

export default connect(common.states, common.actions)(BarCodeMenu);